import { getRequiredTableNames } from '../source/required-csv-files';
import { D4WSourceHandler } from './source';

const D4W_IMPLICIT_TABLES = ['patients_photo'];

const D4W_EXCLUDED_TABLES = [
  'action_log',
  'd4w_lock_system_record',
  'EXCLUDEOBJECT',
  'gtts_users_lockmodes',
  'gtts_web_connectionparameters',
  'ims_user_groups',
  'maintenance_parameters',
  'pa_connectionparameters',
  'pictures',
  'physio_plan_treatment_provided',
  'rs_lastcommit',
  'rs_threads',
  'sec_connectionparameters',
  'sec_file',
  'sec_hardware',
  'sec_log',
  'sec_option',
  'sec_user_ekey',
  'spt_collation_map',
  'synchronize_parameters',
  'synchronize_results',
  'treat_notes_odr',
  'treatm_plan',
  'TBL_nRetCode',
  'ws_registred_info',
];

export function getD4wExportTableNames(): string[] {
  const allTables = getRequiredTableNames(
    new D4WSourceHandler().entityHandlers,
    D4W_IMPLICIT_TABLES
  );
  return allTables
    .filter((table) => !D4W_EXCLUDED_TABLES.includes(table))
    .sort();
}

export function buildTableExportSql(
  tableName: string,
  outputDirectory: string
): string {
  const sanitised = tableName.replace(/"/g, '');
  return [
    `SELECT * FROM ${sanitised};`,
    `OUTPUT TO '${outputDirectory}\\${sanitised}.csv'`,
    `ENCODING 'UTF-8'`,
    `FORMAT TEXT`,
    `QUOTE '"'`,
    `WITH COLUMN NAMES;`,
  ].join('\n');
}

export function generateD4wExportSql(outputDirectory: string): string {
  const tables = getD4wExportTableNames();
  return tables
    .map((table) => buildTableExportSql(table, outputDirectory))
    .join('\n\n');
}
